import { FirstLoginUserProfile } from 'interfaces/subscribe.types';
import { useQuery } from 'react-query';
import { SubscribeAPI } from 'services/subscribe.api';

/**
 * Hook React Query pour récupérer les infos de l'utilisateur en 1ère connexion.
 * GET /auth/first-login
 *
 * - enabled : on ne lance le call que si un token est présent (pré-inscription ou SSO).
 * - En cas de 401/403, l'utilisateur n'a pas accès → le hook renvoie une erreur.
 */
export function useFirstLoginUser(hasToken: boolean) {
  return useQuery<FirstLoginUserProfile, Error>(
    'firstLoginUser',
    async () => {
      const { data } = await SubscribeAPI.getFirstLoginUser();
      return data;
    },
    {
      enabled: hasToken,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  );
}
